import React, { useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import Auth from 'auth';
import { usersVerifyTokenService } from 'services/user';

export default function TermsGate({ children }) {
  const location = useLocation();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (location.pathname === '/logout') {
      setStatus('accepted');
      return;
    }

    const payload = Auth.getPayload();
    if (payload && payload.impersonatedBy) {
      setStatus('accepted');
      return;
    }

    usersVerifyTokenService()
      .then((response) => {
        if (response.data.item && response.data.item.legal_accepted_at) {
          setStatus('accepted');
        } else {
          setStatus('pending');
        }
      })
      .catch(() => {
        setStatus('pending');
      });
  }, [location.pathname]);

  if (status === 'loading') {
    return (
      <div className="legal-accept-loading">
        <Spin size="large" />
      </div>
    );
  }

  if (status === 'pending') {
    if (location.pathname !== '/') {
      sessionStorage.setItem(
        'postLegalRedirect',
        `${location.pathname}${location.search || ''}${location.hash || ''}`,
      );
    }
    return <Redirect to="/accept-terms" />;
  }

  return children;
}
